angular
.module('app.views')
.config(($routeProvider) => {
  $routeProvider.when('/order/:id', {
      template: require('./order.html'),
      controller: 'OrderController'
  });
})
.controller('OrderController', function($scope, $routeParams, $modal, toaster, Order, Account) {
  $scope.reload = function() {
    $scope.loading = true;
    Order.get({id: $routeParams.id}).$promise.then((result) => {
      $scope.order = result;
      // Orders can only be updated if they haven't been shipped
      $scope.needsShipped = (_.indexOf(['on_hold', 'awaiting_payment', 'awaiting_shipment'], $scope.order.status) > -1);
      $scope.canEdit = !!$scope.needsShipped;
      $scope.shipped = ($scope.order.status == 'shipped');

      // Get the associated account
      Account.get({id: $scope.order.account_id}).$promise.then(result => {
        $scope.account = result;
      }, () => {
        console.error('error trying to retrieve the account')
        toaster.pop({
          type: 'error',
          body: `There was an error retrieving the associated account. Please try reloading this page.`,
          timeout: 2000
        });
      });

      // Get all of the orders ahead of this one
      Order.query({
        'filter.until': $scope.order.created_at,
        page_size: 500,
      }, (res) => {
        $scope.ordersAhead = _.filter(res, (o) => {
          // Filter out the current order
          if ($scope.order.id == o.id) {
            return false;
          }
          switch ($scope.order.status) {
            // Orders in "awaiting shipment" are shipped first
            case "awaiting_shipment":
              return (o.status == "awaiting_shipment");
            // Orders in "awaiting_payment" and "on_hold" are shipped last
            case "awaiting_payment":
            case "on_hold":
              return (_.indexOf(['on_hold', 'awaiting_payment', 'awaiting_shipment'], o.status) > -1);
            default:
              return false;
          }
        });
      }, (err) => {
        console.log(err);
      });

      $scope.loading = false;
    }, () => {
      toaster.pop({
        type: 'error',
        body: `Whoops, there was an error trying to retrieve this order.`,
        timeout: 2000
      });
    });
  }

  $scope.edit = function() {
    $modal.open({
      template: require('./order_form.html'),
      controller: 'OrderFormController',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        order: () => $scope.order,
      }
    }).result.then(r => $scope.reload());
  }

  // Load the page
  $scope.reload();
  $scope.loading = true;
});



// WEBPACK FOOTER //
// ./views/order/order_controller.js